var React = require('react');
var toastr = require('toastr');

var w = window;

var FormGroup = require('react-bootstrap/lib/FormGroup');
var Button = require('react-bootstrap/lib/Button');
var EstimatedTimeFormatter = require('../../Formatters/EstimatedTimeFormatter');
var PriceFormatter = require('../../Formatters/PriceFormatter');
var Loading = require('../../Loading');
var AddressLabel = require('../AddressLabel');
var defaultAvatar = require('../../../static/avatar-default.png');

var firebase = require('../../../firebase');
var { fbDb } = firebase;


var marker = null;
var markerLat = 0;
var markerLon = 0;
var repeatTrackBack = false;

var style ={
	container: {
		display: 'flex',
		flexDirection: 'column',
		margin: '15px 0px'
	},

	addressBox: {
		display: 'flex',
		flexDirection: 'column'
	},

	addressBoxItem: {
		display: 'flex',
		padding: '0px 20px',
		alignItems: 'center',
		justifyContent: 'space-around'
	},

	addressBoxAddresses: {
		display: 'flex',
		flexDirection: 'column',
		flex: '1 1 85%'
	},

	divider: {
		width: '100%', 
		height: '1px', 
		backgroundColor: '#ccc',
		margin: '10px 0px'
	},

	avatar: {
		width: '100px', 
		height: '100px', 
		marginRight: '10px'
	},

	pass: {
		color: '#03a6dc'
	}
};

var OrderDetail = React.createClass({

	componentWillUnmount: function() {
		this.repeatTrackBack = false;
	},

	setRoute: function(data) {
		if (!data.origin || !data.destination)
			return;

		data.service.route({
			origin		: data.origin,
			waypoints	: data.waypoints,
			optimizeWaypoints: true,
			destination	: data.destination,
			travelMode	: data.travelMode
		}, (response, status) => {

			if (status === w.google.maps.DirectionsStatus.OK) {
				data.display.setDirections(response);
			} else {
				toastr.error('Erro ao calcular a rota informada');
			}
		})
	},

	getStatus: function(status) {
		var label;

		switch(status) {
			case 1:
				label = 'Em aberto';
				break;

			case 2:
				label = 'Em entrega';
				break;

			case 3:
				label = 'Entregue'
				break;

			case 4:
				label = 'Cancelado'
				break;

			default:
				label = 'Esperando confirmação do pagamento';
				break;
		}

		return label;
	},

	getPackageType: function() {
		var me = this, packageType = me.props.order[0].packageType, type;

		if (packageType === null || packageType === undefined)
			return null;

		if(packageType === 1) {	
			type = (
				<span>
					<i className="icon-box" style={{fontSize: '20px'}}/>
					{'20x20 cm'}
				</span>
			)
		} else if (packageType === 2) {
			type = (
				<span>
					<i className="icon-box" style={{fontSize: '20px'}}/>
					{'40x40 cm'}
				</span>
			)
		} else if (packageType === 0) {
			type = (
				<span>
					<i className="icon-envelope-open-o" style={{fontSize: '20px'}}/>
					{'Envelope'}
				</span>
			)
		}

		return (
			<div>
				<div style={style.divider}/>
				<div style={{display: 'flex'}}>
					{type}
				</div>
			</div>
		);
	},

	getDirections: function() {
		var me = this, directions = me.props.order[0].addresses, len = directions.length, places = {}, waypoint = [];

		directions.forEach((place, index) => {
			if(index === 0) {
				places['origin'] = {lat: place.lat, lng: place.lon};
			} else if (index === (len - 1)) {
				places['destination'] = {lat: place.lat, lng: place.lon};
			} else {
				waypoint.push({location: {lat: place.lat, lng: place.lon}, stopover: true});
				places['waypoints'] = waypoint;
			}
		});

		return places;
	},

	getAddressesBox: function() {
		var me = this, addresses = me.props.order[0].addresses;

		let box = addresses.map((current, index) => {
			return (
				<div key={index} style={style.addressBox}>
					<div style={style.divider} />

					<div style={style.addressBoxItem}>
						<AddressLabel arriveOrder={index}/>
						<div style={style.addressBoxAddresses} >
							<b>{current.street + ', ' + current.number}</b>
							<span>{current.complement + ' - ' + current.description}</span>
							<span><b style={style.pass}>{"Código de segurança"}</b> {current.verificationCode}</span>
						</div>
					</div>
				</div>
			)
		});

		return box;
	},

	getCourierInfo: function() {
		var me = this, props = me.props, avatar = null;

		/*if (props.avatarCourier)
			avatar = "teste";//(<img style={style.avatar} href={props.avatarCourier} alt="profile"/>)
		else if (!props.avatarCourier && props.nameCourier)
			avatar = "teste";//(<img src={defaultAvatar} style={style.avatar} alt="profile"/>)*/

		return (
			<div style={{display: 'flex'}}>
				{/*avatar*/}

				<div id="CourierData" style={style.addressBox}>
				</div>
			</div>
		)
	},

	unwrapOrder: function(order, key) {
		return Object.assign({}, order, {
			key: key
		});
	},

	trackBack: function() {
		var me = this;
		const courier = me.props.order[0].courier;
		fetch("https://us-central1-ajato-29abc.cloudfunctions.net/courier_update_location?courier="+courier);
		if(me.repeatTrackBack) {
			setTimeout(function() {
				me.trackBack();
			}, 10000);
		}
	},

	render: function() {

		if (!this.props.order.length)
			return <div/>;
		
		var me = this, 
			props = me.props, 
			google = w.google,
			directions = me.getDirections(),
			gService = new google.maps.DirectionsService(),
			gDisplay = new google.maps.DirectionsRenderer(),
			order = props.order[0],
			courier = me.props.order[0].courier;

		gDisplay.setMap(null);

		me.setRoute({
			origin: directions.origin,
			waypoints: directions.waypoints,
			destination: directions.destination,
			travelMode: google.maps.TravelMode.DRIVING,
			service: gService,
			display: gDisplay
		});

		var markerLatLon = {lat: markerLat, lng: markerLon}
		var image = 'https://firebasestorage.googleapis.com/v0/b/ajato-e2d54.appspot.com/o/ic_pin_motoboy.png?alt=media&token=4f163b05-d129-4ecb-9c91-c4bfb6e462e0';
		marker = new google.maps.Marker({
            position: markerLatLon,
            map: w.GMap,
            icon: image
        });

        gDisplay.setMap(w.GMap);
        
        if(order.status == 2) {
        	var ref = fbDb.ref('courierLocation/' + courier);

        	me.repeatTrackBack = true;
        	me.trackBack();

	        ref.once('value', (snap) => {
	        	if(snap.val()) {
	        		var values = snap.val();
	        		if(values.lat) {
	        			markerLat = values.lat;
	        		}
	        		if(values.lon) {
	        			markerLon = values.lon;
	        		}
	        		if(markerLat > 0 && markerLon > 0) {
	        			marker.setMap(null);
			        	var _markerLatLon = {lat: markerLat, lng: markerLon}
			        	marker = new google.maps.Marker({
				            position: _markerLatLon,
				            map: w.GMap,
				            icon: image
			        	});
			        	marker.setMap(w.GMap);
	        		}
	        	}
	        });

	        ref.on('child_changed', snap => {
	        	if (snap.key == "lat") {
	        		markerLat = snap.val();
	        	}
	        	if (snap.key == "lon") {
	        		markerLon = snap.val();
	        	}
	        	marker.setMap(null);
	        	var _markerLatLon = {lat: markerLat, lng: markerLon}
	        	marker = new google.maps.Marker({
		            position: _markerLatLon,
		            map: w.GMap,
		            icon: image
	        	});
	        	marker.setMap(w.GMap);
			});
        }

		var _cd = document.getElementById('CourierData');
		if(_cd) {
			while(_cd.firstChild){
			    _cd.removeChild(_cd.firstChild);
			}
		}

        if(courier) {
        	var _ref = fbDb.ref('couriers/' + courier.id);
			_ref.once('value', (snap) => {
				if(snap.val()) {
					if(snap.val().info) {
						var name = snap.val().info.name;
						var phone = snap.val().info.phone;
						var cd = document.getElementById('CourierData');
						while(cd.firstChild){
						    cd.removeChild(cd.firstChild);
						}
						cd.insertAdjacentHTML('beforeend', '<span> <i className="icon-user"/><b id="nameCourier">Entregador: '+name+' </b></span>');
						cd.insertAdjacentHTML('beforeend', '<span> <i className="icon-phone"/><b id="phoneCourier">Telefone: '+phone+' </b></span>');
					}
				}
			});
        }

		return (
			<div style={style.container}>

				<Loading loading={props.loading} />

				<span><b>{"Status"} </b> {me.getStatus(order.status)}</span>

				{me.getPackageType()}

				{me.getAddressesBox()}

				<div style={style.divider}/>

				<span><b>{"Pedido"} </b> {order.order}</span>
				<span><b>{"Tempo estimado"} </b> <EstimatedTimeFormatter data={order.estimatedTime}/></span>
				<span><b>{"Preço"} </b> <PriceFormatter data={order.value} /></span>

				<div style={style.divider}/>

				{me.getCourierInfo()}

				<FormGroup>
					<Button onClick={() => { 
								marker.setMap(null);
								gDisplay.setMap(null);
								props.onClick() 
							}} 
							block 
							bsStyle="default" 
							style={{backgroundColor: '#748297', color: '#fff', marginTop: '15px'}}>
						{"Voltar"}
					</Button>
				</FormGroup>
			</div>
		);
	}

});

module.exports = OrderDetail;


// WEBPACK FOOTER //
// ./src/components/Client/MyOrders/OrderDetail.jsx